export default "__VITE_ASSET__QKGvscyX__"